import React from 'react';
import { useIsTablet } from '@guildeducationinc/catalog-tools';
import { Typography } from '@guildeducationinc/recess';
import styles from './ShelfBannerHeader.module.scss';

export const ShelfBannerHeader: React.FC = () => {
	const isTablet = useIsTablet();

	return (
		<div className={styles.headingContainer}>
			<div className={styles.heading}>
				<Typography className={styles.headingText} variant='h1'>
					Let&apos;s find the right program
				</Typography>
				<Typography className={styles.subheading} variant='body2'>
					Browse your program recommendations or search for programs, areas of interest, or schools.
				</Typography>
			</div>
			{!isTablet && (
				<img
					alt=''
					className={styles.graphic}
					data-testid='green-curve-graphic'
					src='https://imgix.guildeducation.com/catalog-frontend/green_curve_graphic.svg'
				/>
			)}
		</div>
	);
};
